import {
  ErrorTypes,
  ErrorTypeToDisplay,
  OrderData,
  OrderSectionErrors,
  OrdersErrors,
  ValidationOrderData,
} from "@shared/features/trades/common/types";
import { OrderStatus, OrderTypes } from "@shared/types";
import { ValidationTargetData } from "@shared/features/signals/EditSignal/types";
import { set, sumBy } from "lodash";

export const getDefaultOrdersSectionErrors = (
  orders: OrderData[]
): OrderSectionErrors => ({
  section: {},
  orders: orders.reduce((acc, _, index) => {
    acc[index] = {};
    return acc;
  }, {} as { [key: number]: ErrorTypeToDisplay }),
});

export const addError = (
  orderErrors: OrderSectionErrors,
  errorType: ErrorTypes,
  orderIndex?: number,
  displayMessage?: string
) => {
  orderErrors.section[errorType] = displayMessage;
  if (orderIndex !== undefined) {
    set(orderErrors.orders, [orderIndex, errorType], displayMessage);
  }
};

export const validateNumberOfBreakoutOrders = (
  entries: (ValidationOrderData | ValidationTargetData)[],
  ordersErrors: OrdersErrors
) => {
  entries
    .slice(2)
    .map((_, index) =>
      addError(
        ordersErrors[OrderTypes.ENTRY],
        ErrorTypes.BREAKOUT_TOO_MANY_ENTRIES,
        index
      )
    );
};

export const validateNumberOfOrders: {
  (
    entries: ValidationOrderData[],
    ordersErrors: OrdersErrors,
    isBreakout: boolean,
    minAmount: number,
    quantity: number,
    minQuantity: number
  ): void;
  (
    entries: ValidationTargetData[],
    ordersErrors: OrdersErrors,
    isBreakout: boolean
  ): void;
} = (
  entries: (ValidationOrderData | ValidationTargetData)[],
  ordersErrors: OrdersErrors,
  isBreakout: boolean,
  minAmount?: number,
  quantity?: number,
  minQuantity?: number
) => {
  const checkAtLeastOneEntryError = () => {
    if (validEntries.length < 1) {
      addError(ordersErrors[OrderTypes.ENTRY], ErrorTypes.AT_LEAST_ONE_ENTRY);
    }
  };

  const validEntries = entries.filter(
    (order) => order.status !== OrderStatus.CANCELLED
  );
  const isTradeOrderValidation = [minAmount, quantity, minQuantity].every(
    (param) => param !== undefined
  );
  if (isBreakout) {
    validateNumberOfBreakoutOrders(entries, ordersErrors);
  }
  if (!isTradeOrderValidation) {
    checkAtLeastOneEntryError();
    return;
  }

  const tradeAmount = sumBy(
    validEntries as ValidationOrderData[],
    (target) => target.amount || 0
  );
  const isInvalidTrade =
    (tradeAmount < (minAmount ?? 0) && (quantity ?? 0) < (minQuantity ?? 0)) ||
    (!tradeAmount && !quantity);
  if (isInvalidTrade) {
    checkAtLeastOneEntryError();
  }
};
